/**
 * Input component
 */

import {InputHTMLAttributes, forwardRef} from 'react';
import {cn} from '../../utils/cn';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({className, error, ...props}, ref) => {
    return (
      <input
        ref={ref}
        className={cn(
          'w-full px-3 py-2 rounded-lg border',
          'bg-white dark:bg-[#2D2D30]',
          'text-gray-900 dark:text-[#CCCCCC]',
          'placeholder-gray-500 dark:placeholder-[#6A6A6A]',
          'focus:outline-none focus:ring-2 focus:ring-accent dark:focus:ring-[#4A9EFF] focus:ring-offset-0',
          'disabled:opacity-50 disabled:cursor-not-allowed',
          'transition-colors',
          error
            ? 'border-red-300 dark:border-red-600 focus:ring-red-500'
            : 'border-gray-300 dark:border-gray-700',
          className
        )}
        {...props}
      />
    );
  }
);

Input.displayName = 'Input';

